module.exports = __webpack_public_path__ + "static/logo-eurosport-6caa3ec3a989605654bf4523d8753bc6.png";